export const canProceed = error => {
    //console.log(error);
    const flatError = Object.values(error).flat();
    const isInValid = flatError.every(e => e.hasError === false);
    return !isInValid;
  };